// src/slices/branchesSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TopicState {
  id: number;
}

const initialState: TopicState = {
  id: 1
};

const TopicSlice = createSlice({
  name: 'topic',
  initialState,
  reducers: {
    updateTopicId: (state: TopicState, action: PayloadAction<number>) => {
      state.id = action.payload;
    }
  }
});

export const { updateTopicId } = TopicSlice.actions;
export default TopicSlice.reducer;
